// 查看详情
function logCateDetail() {
  window.log && window.log('yx_center_kplyx', 'more_detail');
}

// 离开页面上报当前卡片数量
function logRemainCardNum(cardNum) {
  window.log && window.log('yx_center_kplyx', 'card_number', cardNum);
}

// 上报搜索参数
function logSearchActionParams(query) {
  const values = ['mainCid', 'refType', 'cidScope', 'sortField', 'sortOrder', 'deptId'].reduce((total, cur) => {
    total.push(query[cur] == null ? '' : query[cur]);
    return total;
  }, []);

  window.log && window.log('yx_center_kplyx', 'kpl_search', ...values);
}

export { logCateDetail, logRemainCardNum, logSearchActionParams };
